import React from "react";
import Container from "./styled";
import { IoClose } from "react-icons/io5";
import { BsTelephoneFill } from "react-icons/bs";
import { BsWhatsapp } from "react-icons/bs";
import disableScroll from "disable-scroll";
import CheckAnimation from "./lottieAnimation";

export default class ArrepentimientoConfirmacion extends React.Component {
  render() {
    // Disable scroll on
    this.props.toggleScroll != "" && disableScroll.on();
    return (
      <Container>
        <div className="box">
          <div className="closeButtonContainer">
            <a onClick={this.props.handleClose}>
              <IoClose />
            </a>
          </div>
          <h3 className="opacidad04">
            Tus arrepentimiento fue enviado con éxito
          </h3>
          <p className="opacidad04">
            Dentro de poco nos vamos a comunicar con vos
          </p>
          <div className="opacidad12">
            <CheckAnimation></CheckAnimation>
          </div>
          <p id="contacto" className="opacidad20">
            Si tenes alguna duda o necesitas más informacion, podes contactarte
            al:
          </p>
          <a id="contactoButton" className="opacidad20">
            <span>
              <BsTelephoneFill />
            </span>
            0800-0000-0000
          </a>
          <a
            id="contactoButton"
            className="opacidad20"
            href="https://api.whatsapp.com/send?phone=541128061469&text=%C2%A1Hola%2C%20me%20gustar%C3%ADa%20obtener%20m%C3%A1s%20informaci%C3%B3n%20sobre%20el%20Seguro%20de%20Bici!%20"
            target="_blank"
          >
            <span>
              <BsWhatsapp />
            </span>
            0800-0000-0000
          </a>
        </div>
      </Container>
    );
  }
}
